'use client';

import { useState } from 'react';
import { useAuth } from '@/platform/auth/useAuth';
import { reportContent } from '@/platform/moderation/reportContent';
import type { ReportTargetType } from '@/platform/moderation/api';

type Props = {
  targetType: ReportTargetType;
  targetId: string;
  parentId?: string;
  sellerUserId?: string;
  reportedUserId?: string;
  label?: string;
  className?: string;
};

export function ReportButton({
  targetType,
  targetId,
  parentId,
  sellerUserId,
  reportedUserId,
  label = 'Report',
  className,
}: Props) {
  const { isAuthenticated } = useAuth();
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  if (!isAuthenticated) return null;

  async function onReport() {
    setBusy(true);
    setError('');
    setStatus('');
    try {
      await reportContent({
        targetType,
        targetId,
        parentId,
        sellerUserId,
        reportedUserId,
        reason: 'other',
      });
      setStatus('Report submitted — thank you');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Report failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <span className={className}>
      <button type="button" className="btn btn-secondary" disabled={busy} onClick={() => void onReport()}>
        {busy ? 'Reporting…' : label}
      </button>
      {status ? <span className="text-muted"> {status}</span> : null}
      {error ? <span className="form-error"> {error}</span> : null}
    </span>
  );
}
